import { ChangeDetectionStrategy, Component, input, InputSignal, output } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';

import { TitleComponent } from '@connect-services/client/components/field-intervention-title/title/title.component';
import { ButtonComponent, ButtonType } from '@connect-services/src/lib/components/button/button.component';
import { RessourcesModule } from '@ressources/client/ressources.module';
import { FormGroupType } from '@shared/client/models/form.model';

export interface LayerFormType {
    bookmarkedColumns?: FormArray<FormGroup<BookmarkedColumnFormType>>;
    businessIdentifier?: FormControl<string | null>;
    isVisible: FormControl<boolean | null>;
    name: FormControl<string>;
    order: FormControl<number | null>;
    versionLock?: FormControl<boolean>;
}

export interface BookmarkedColumnFormType extends FormGroupType {
    column: FormControl<string>;
    isBookmarked: FormControl<boolean>;
    order: FormControl<number | null>;
}

export const WIDTH_PX_BREAKPOINT = 700;

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ButtonComponent, TitleComponent, RessourcesModule],
    selector: 'app-edit-layer-template',
    styleUrl: '../project-settings-layer-detail-template/project-settings-layer-detail-template.component.scss',
    templateUrl: './edit-layer-template.component.html',
})
export class EditLayerTemplateComponent {
    public goToPreviousPage = output<void>();
    public readonly isFormValid: InputSignal<boolean> = input.required();
    public submit = output<void>();

    protected readonly ButtonType = ButtonType;
}
